import request from '@/utils/request'

// 查询主播等级列表
export function listAnchorsLevel(query) {
  return request({
    url: '/trade/anchors/level/list',
    method: 'get',
    params: query,
  })
}

// 查询主播等级分页
export function pageAnchorsLevel(query) {
  return request({
    url: '/trade/anchors/level/page',
    method: 'get',
    params: query,
  })
}

// 查询主播等级详细
export function getAnchorsLevel(data) {
  return request({
    url: '/trade/anchors/level/detail',
    method: 'get',
    params: data,
  })
}

// 新增主播等级
export function addAnchorsLevel(data) {
  return request({
    url: '/trade/anchors/level/add',
    method: 'post',
    data: data,
  })
}

// 修改主播等级
export function updateAnchorsLevel(data) {
  return request({
    url: '/trade/anchors/level/edit',
    method: 'post',
    data: data,
  })
}

// 删除主播等级
export function delAnchorsLevel(data) {
  return request({
    url: '/trade/anchors/level/delete',
    method: 'post',
    data: data,
  })
}
